import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";

export default function ForSaleModal(props) {
  const itemprops = props.itemProps;
  const containerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const checkOverflow = () => {
      setIsScrollable(el.scrollHeight - el.clientHeight > 4);
    };
    checkOverflow();
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);
    return () => observer.disconnect();
  }, [itemprops.itemContent]);

  return (
    <>
      <div
        className={classNames("news-modal-item-container", {
          "is-scrollable": isScrollable,
        })}
        ref={containerRef}
      >
        <div className="heading-section">
          <div
            className="modal-title section-heading"
            dangerouslySetInnerHTML={{ __html: itemprops.itemTitle }}
          ></div>
        </div>
        <div className="modal-title section-subheading">
          {itemprops.itemDate}
        </div>
        <div
          className="news-modal-item-text"
          dangerouslySetInnerHTML={{ __html: itemprops.itemContent }}
        ></div>
      </div>
    </>
  );
}
